import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { UserSnapshotPermission } from 'types/models/UserSnapshotPermission';

export const createSnapshotPermission = async ({
  userId,
  snapshotId,
}: {
  userId: number;
  snapshotId: number;
}): Promise<UserSnapshotPermission> => {
  const response = await axios.post(
    `/api/users/${userId}/snapshot/${snapshotId}/permissions`
  );
  return response.data as UserSnapshotPermission;
};

type UseCreateSnapshotPermissionOptions = {
  config?: MutationConfig<typeof createSnapshotPermission>;
};

export const useCreateSnapshotPermission = ({
  config,
}: UseCreateSnapshotPermissionOptions = {}) => {
  return useMutation({
    onSuccess: (createdPermissions) => {
      queryClient.invalidateQueries(['user', createdPermissions.user_id]);
    },
    ...config,
    mutationFn: createSnapshotPermission,
  });
};
